import React, { useEffect, useState } from 'react';
import { Slider, Stack, Pagination } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ProductCard from '../Common/Cards/ProductCards';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCategory } from '../../Redux/CategoryRedux';
import { getAllProducts } from '../../Redux/ProductRedux';

const PrettoSlider = styled(Slider)({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 45,
    height: 45,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#52af77',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});
function Products() {
  const dispatch = useDispatch();
  const { allCategory } = useSelector((state) => state.categoryRedux);
  const { allProducts } = useSelector((state) => state.productRedux);
  // const [selectedValue, setSelectedValue] = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);

  useEffect(() => {
    dispatch(getAllCategory());
    dispatch(getAllProducts()).catch((error) => {
      console.error('error', error);
    });
  }, [dispatch]);

  // const options = [
  //   { value: '1', label: 'Default sorting' },
  //   { value: '2', label: 'Sort by popularity' },
  //   { value: '3', label: 'Sort by average rating' },
  //   { value: '4', label: 'Sort by latest' },
  //   { value: '5', label: 'Sort by price: low to high' },
  //   { value: '6', label: 'Sort by price: high to low' },
  // ];

  // Handler for checkbox click
  const handleCategoryChange = (event, category) => {
    if (event.target.checked) {
      setSelectedCategories([...selectedCategories, category]);
    } else {
      setSelectedCategories(
        selectedCategories.filter((item) => item !== category)
      );
    }
  };

  const filteredProducts =
    selectedCategories.length === 0
      ? allProducts
      : allProducts.filter((product) =>
          product.underCategory.some((cat) =>
            selectedCategories.includes(cat.category)
          )
        );

  const marks = [
    {
      value: 0,
      label: '₹ 0',
    },
    {
      value: 4700,
      label: '₹ 5000',
    },
  ];

  // const handleSelectChange = (e) => {
  //   setSelectedValue(e.target.value);
  // };
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts =
    filteredProducts.length > 0
      ? filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct)
      : [];

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div className='container-fluid  my-5'>
      <div className='row d-flex align-items-center justify-content-center mb-2'>
        <div className='col-12 d-flex justify-content-center'>
          <h3 className='underline'>Our Products</h3>
        </div>
      </div>
      <div className='row'>
        <div className='d-flex col-md-12 mb-2 justify-content-end'>
          <button
            className='btn btn-outline-success'
            type='button'
            data-bs-toggle='offcanvas'
            data-bs-target='#filterSidebar'
            aria-controls='filterSidebar'
          >
            <i className='bi bi-sliders'></i>
          </button>
        </div>
        <div
          className='offcanvas offcanvas-end'
          tabIndex='-1'
          id='filterSidebar'
          aria-labelledby='filterSidebarLabel'
        >
          <div className='offcanvas-header'>
            <h5
              className='offcanvas-title'
              id='filterSidebarLabel'
            >
              Categories
            </h5>
            <button
              type='button'
              className='btn-close text-reset'
              data-bs-dismiss='offcanvas'
              aria-label='Close'
            ></button>
          </div>
          <div className='offcanvas-body'>
            <FormGroup
              className='p-1'
              sx={{
                justifyContent: 'center',
                gap: 2,
              }}
            >
              {allCategory.categories && allCategory.categories.length > 0 ? (
                allCategory.categories.map((category) => (
                  <FormControlLabel
                    key={category._id}
                    control={
                      <Checkbox
                        sx={{
                          '& .MuiSvgIcon-root': { fontSize: 17 },
                        }}
                        onChange={(e) =>
                          handleCategoryChange(e, category.category)
                        }
                        checked={selectedCategories.includes(category.category)}
                      />
                    }
                    label={<p style={{ margin: 0 }}>{category.category}</p>}
                  />
                ))
              ) : (
                <p>No categories available</p>
              )}
            </FormGroup>
          </div>
        </div>
        <div className='col-md-12 col-xs-12'>
          {/* {currentProducts.map((currentProducts) => (
            <ProductCard currentProducts={currentProducts} />
          ))} */}
          <ProductCard currentProducts={currentProducts} />
          {currentProducts.length > 0 ? (
            <div className='my-3 d-flex justify-content-center'>
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color='success'
                />
              </Stack>
            </div>
          ) : (
            <div className='my-5 d-flex justify-content-center col-md-10'>
              <h4>No Products Available</h4>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Products;
